/**
 * ## Notification manager component
 *
 * @module src/components/notification
*/

'use strict';

const conf = require('../../config');
const layout = require('../layout');

let timer = null;
let type = 'top';

const setBlocker = (block) => {
    switch (block) {
    case 'header': {
        $('#notification_block_right').css('height', '200px');
        $('#notification_block_right').css('width', '220px');
        $('#notification_block_right').css('display', 'block');
        $('#notification_block_top').css('display', 'block');
        break;
    }
    case 'fullheader': {
        $('#notification_block_right').css('height', `${conf.vars.viewportHeight}px`);
        $('#notification_block_right').css('width', '220px');
        $('#notification_block_right').css('display', 'block');
        $('#notification_block_top').css('height', '100px');
        $('#notification_block_top').css('display', 'block');
        break;
    }
    case 'full': {
        $('#notification_block_right').css('height', `${conf.vars.viewportHeight}px`);
        $('#notification_block_right').css('width', '220px');
        $('#notification_block_right').css('display', 'block');
        $('#notification_block_top').css('display', 'block');
        break;
    }
    case 'block': {
        $('#notification_block_right').css('height', `${conf.vars.viewportHeight}px`);
        $('#notification_block_right').css('width', `${conf.vars.viewportWidth}px`);
        $('#notification_block_right').css('display', 'block');
        break;
    }
    default: {
        $('#notification_block_right').css('display', 'none');
        $('#notification_block_top').css('display', 'none');
        break;
    }
    }
};

/**
 * Notification display.
 */
const create = (opt, data, callback) => {
    type = opt.position;
    $('#notification').css('display', 'block');
    TweenMax.set('#notification', {
        transformOrigin: '0% 0%',
    });
    $('#notification_center').css('width', opt.width);
    if (!opt.hasOwnProperty('color')) {
        opt.color = '#ef0000';
    }
    $('#notification_block_top').css('height', '50px');
    setBlocker(opt.block);
    layout.resize();
    $('#notification_h1').html(opt.h1);
    $('#notification_body').html(opt.body);
    $('#notification_h1').removeClass('notification_float');
    if (opt.body === '') {
        $('#notification_h1').addClass('notification_float');
    }
    let buttons = '<div class="notification_buttons">';
    let c = 0;
    opt.buttons.forEach((button) => {
        ++c;
        buttons += `<div class="btn14 notification_button" id="notification_button${c}" \
                        data-value="${button.value}">${button.description}</div>`;
    });
    buttons += '<div class="clear"></div></div>';
    $('#notification_buttons').html(buttons);
    $('.notification_button').click((e) => {
        // event, type, data to create component, return value to populate
        e.stopPropagation();
        callback(null, $(`#${e.target.id}`).data('value'));
    });
    switch (opt.position) {
    case 'top': {
        $('#notification_center').css('border-bottom', '0px');
        $('#notification_center').css('border-top', `8px solid ${opt.color}`);
        $('#notification_center').css('border-radius', '0px 0px 4px 4px');
        TweenMax.to('#notification', 0, {
            alpha: 1,
            y: 0 - $('#notification').height(),
            delay: 0.3,
            ease: Power2.easeOut,
        });
        TweenMax.to('#notification', conf.vars.interfaceSpeed, {
            alpha: 1,
            y: 0,
            delay: 0.3,
            ease: Power2.easeOut,
        });
        break;
    }
    case 'bottom': {
        if (conf.vars.NODE_ENV.indexOf('ios') > -1) {
            $('#notification_center').css('border-top', '20px');
        } else {
            $('#notification_center').css('border-top', '0px');
        }
        $('#notification_center').css('border-bottom', `8px solid ${opt.color}`);
        $('#notification_center').css('border-radius', '4px 4px 0px 0px');
        TweenMax.to('#notification', 0, {
            alpha: 1,
            y: conf.vars.viewportHeight,
            ease: Power2.easeOut,
        });
        TweenMax.to('#notification', conf.vars.interfaceSpeed, {
            alpha: 1,
            y: conf.vars.viewportHeight - $('#notification').height(),
            ease: Power2.easeOut,
        });
        break;
    }
    default:
    }
    if (opt.seconds !== 0) {
        timer = setTimeout(() => {
            destroy(120);
        }, opt.seconds * 1000);
    }
    $('#notification_block_right, #notification_block_top').off();
    $('#notification_block_right, #notification_block_top').fastClick((e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
    });
};

const destroy = () => {
    clearTimeout(timer);
    if ($('#notification').position().top < 1) {
        TweenMax.to('#notification', conf.vars.interfaceSpeed, {
            alpha: 1,
            y: -200,
            ease: Power2.easeIn,
            onComplete: hide,
        });
    } else {
        TweenMax.to('#notification', conf.vars.interfaceSpeed, {
            alpha: 1,
            y: conf.vars.viewportHeight + 200,
            ease: Power2.easeIn,
            onComplete: hide,
        });
    }
};

const hide = () => {
    $('#notification').css('display', 'none');
};

const appendBody = (html) => {
    $('#notification_body').append(html);
};

const getType = () => {
    return type;
};


module.exports = {
    create,
    destroy,
    appendBody,
    setBlocker,
    getType,
};



/** WEBPACK FOOTER **
 ** ./src/components/notification/index.js
 **/